// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cGfK","colBig":"styles_colBig__oZEAU","colSmall":"styles_colSmall__2wGkR"};